<template>
  <div class="case-detail-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="breadcrumb">
        <span class="breadcrumb-item link" @click="goBack">造价案例</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item">{{ caseInfo.title || '案例详情' }}</span>
      </div>
    </div>

    <!-- 查看更多 -->
    <div class="view-more-section">
      <div class="images-container">
        <div class="image-card">
          <img :src="$getImageUrl(caseInfo.cover_image)" alt="封面" class="case-image">
        </div>
        <div v-if="effectDiagramList.length > 0" class="image-card">
          <img :src="$getImageUrl(effectDiagramList[0])" alt="效果图" class="case-image">
        </div>
        <div v-else-if="getCaseImages().length > 1" class="image-card">
          <img :src="$getImageUrl(getCaseImages()[1])" alt="案例图片" class="case-image">
        </div>
        <div v-else class="image-card">
          <img :src="$getImageUrl(caseInfo.cover_image)" alt="封面副图" class="case-image">
        </div>
      </div>
      <div class="view-more" @click="viewMoreImages">
        <img src="@/assets/image/al/look1.png" alt="查看更多" class="view-more-icon">
        <span style="font-size: 18px;">查看更多</span>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <div v-if="showImagePreview" class="image-preview-mask" @click="closeImagePreview">
      <div class="image-preview-container" @click.stop>
        <div class="preview-header">
          <h3 class="preview-title">案例图片</h3>
          <div class="preview-header-actions">
            <button class="preview-jump-btn" @click="goToCaseNews">
              <span>查看个人简介</span>
              <i class="el-icon-arrow-right" />
            </button>
            <img
              class="preview-close-btn"
              src="@/assets/image/al/close.png"
              alt="关闭"
              @click="closeImagePreview"
            >
          </div>
        </div>
        <div class="preview-content">
          <div
            v-for="(image, index) in allImages"
            v-show="index === currentImageIndex"
            :key="index"
            class="preview-image-wrapper"
          >
            <img
              :src="$getImageUrl(image)"
              :alt="`案例图片 ${index + 1}`"
              class="preview-image"
            >
          </div>
        </div>
        <div class="preview-nav">
          <button
            class="nav-btn prev-btn"
            :disabled="currentImageIndex === 0"
            @click="prevImage"
          >
            <i class="el-icon-arrow-left" />
          </button>
          <button
            class="nav-btn next-btn"
            :disabled="currentImageIndex === allImages.length - 1"
            @click="nextImage"
          >
            <i class="el-icon-arrow-right" />
          </button>
        </div>
        <!-- 缩略图导航 -->
        <div v-if="allImages.length > 1" class="thumbnail-nav">
          <div
            v-for="(image, index) in allImages"
            :key="index"
            class="thumbnail-item"
            :class="{ active: index === currentImageIndex }"
            @click="goToImage(index)"
          >
            <img
              :src="$getImageUrl(image)"
              :alt="`缩略图 ${index + 1}`"
              class="thumbnail-img"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="project-content">
      <div v-html="caseInfo.project_info" />

      <!-- 项目文档信息 -->
      <div class="document-info">
        <div class="document-header">
          <div class="document-icon">
            <i class="el-icon-document" />
          </div>
          <div class="document-title">国家会展中心项目工程二期(总概算表)</div>
          <div class="document-meta">
            <span class="date">2025-04-08</span>
            <span class="size">3.9MB</span>
            <span class="preview" @click="handleDownload">预览</span>
          </div>
        </div>
      </div>

      <!-- 项目效果图 -->
      <div class="project-rendering">
        <h3 class="section-title">项目效果图</h3>
        <div class="rendering-image">
          <img :src="$getImageUrl(effectDiagramList[0] || caseInfo.cover_image)" alt="项目效果图" class="project-image">
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <button v-if="caseInfo.cost_engineer_id" class="btn btn-consult" @click="goConsult">
          立即咨询
        </button>
        <!-- <button class="btn btn-download" @click="isConsultVisible = true">
          免费下载
        </button> -->
        <button class="btn btn-download" @click="handleDownload">
          {{ caseInfo.is_free === 1 ? '点击下载' : `¥${displayAmount} 购买并下载` }}
        </button>
        <!-- 收藏按钮 -->
        <button class="btn btn-fav" :class="{ collected: isCollected }" @click="handleCollect">
          <span v-if="!isCollected">☆ 收藏</span>
          <span v-else>★ 已收藏</span>
        </button>
      </div>
    </div>

    <!-- 免费弹窗 -->
    <div v-if="isConsultVisible" class="zf-modal-mask" @click.self="closeAll">
      <div class="zf-modal">
        <img class="zf-modal-close" src="@/assets/image/al/close.png" alt="关闭" @click="closeAll">
        <div class="zf-modal-title">资料下载</div>
        <div class="zf-modal-file">
          <img class="zf-file-icon" src="@/assets/image/al/bg.png" alt="文件">
          <div class="zf-file-meta">
            <div class="zf-file-name">国家会展中心项目工程二期(总概算表)</div>
            <div class="zf-file-sub">2025-04-08&nbsp;&nbsp;3.9MB</div>
          </div>
        </div>
        <div class="zf-modal-tip">此案例的资料免费哦，可以直接下载~</div>
        <button class="zf-primary-btn" @click="toDownloadFromConsult">点击下载</button>
      </div>
    </div>

    <!-- 收费下载弹窗 -->
    <div v-if="isDownloadVisible" class="zf-modal-mask" @click.self="closeAll">
      <div class="zf-modal">
        <img class="zf-modal-close" src="@/assets/image/al/close.png" alt="关闭" @click="closeAll">
        <div class="zf-modal-title">资料下载</div>
        <div class="zf-modal-file">
          <img class="zf-file-icon" src="@/assets/image/al/bg.png" alt="文件">
          <div class="zf-file-meta">
            <div class="zf-file-name">国家会展中心项目工程二期(总概算表)</div>
            <div class="zf-file-sub">2025-04-08&nbsp;&nbsp;3.9MB</div>
          </div>
        </div>
        <div class="zf-form">
          <div class="zf-input">
            <span class="zf-input-prefix">￥</span>
            <input v-model="chargeAmount" disabled type="text" placeholder="请输入收费金额">
          </div>

          <!-- 支付方式选择 -->
          <div class="zf-payment-methods">
            <div class="payment-title">选择支付方式</div>
            <div class="payment-options">
              <div
                class="payment-option"
                :class="{ active: selectedPaymentMethod === 'wechat' }"
                @click="selectPaymentMethod('wechat')"
              >
                <img src="@/assets/image/al/wx.png" alt="微信">
                <span>微信支付</span>
              </div>
              <div
                class="payment-option"
                :class="{ active: selectedPaymentMethod === 'alipay' }"
                @click="selectPaymentMethod('alipay')"
              >
                <img src="@/assets/image/al/zfb.png" alt="支付宝">
                <span>支付宝</span>
              </div>
              <div
                class="payment-option"
                :class="{ active: selectedPaymentMethod === 'yue' }"
                @click="selectPaymentMethod('yue')"
              >
                <div class="yue-icon">余</div>
                <span>余额支付</span>
              </div>
            </div>
          </div>

          <div class="zf-paybox">
            <div class="zf-qrcode">
              <img
                v-if="selectedPaymentMethod !== 'yue' && paymentData.pay_url"
                :src="paymentData.pay_url"
                alt="支付二维码"
                class="qr-code-img"
              >
              <div v-else class="qr-placeholder">
                <span v-if="selectedPaymentMethod === 'yue'">余额支付无需扫码</span>
                <span v-else>加载中...</span>
              </div>
            </div>
            <div class="zf-payinfo">
              <div class="zf-amount">应付金额：<span>¥{{ paymentData.amount || caseInfo.price || chargeAmount }}</span></div>
              <div class="zf-paytypes">
                <span v-if="selectedPaymentMethod === 'wechat'">使用微信扫码支付</span>
                <span v-else-if="selectedPaymentMethod === 'alipay'">使用支付宝扫码支付</span>
                <span v-else-if="selectedPaymentMethod === 'yue'">使用账户余额支付</span>
                <span v-else>请选择支付方式</span>
              </div>
              <div class="zf-agree">支付即视为您同意《智蜂智造付费协议》</div>
            </div>
          </div>
        </div>
        <button class="zf-primary-btn" style="margin-top: 10px;" @click="confirmDownload">立即支付</button>
      </div>
    </div>
    <!-- 用户评分 -->
    <div v-if="ratings && ratings.length" class="user-rating-section">
      <div class="rating-header">
        <span class="rating-label">用户评分</span>
      </div>
      <div v-for="item in ratings" :key="item.id" class="reviews-list">
        <div class="review-item">
          <div class="review-content">
            <div class="user-avatar">
              <img :src="$getImageUrl(item.avatar)" alt="用户头像" class="avatar-img">
            </div>
            <div class="user-info">
              <span class="username">{{ item.username }}</span>
              <span class="review-date">{{ item.createtime }}</span>
            </div>
          </div>
          <div class="rating-stars">
            <span class="rating-score">{{ item.rating_text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCostCaseDetail, createPayOrder, collectCase } from '@/api/costcase'
import request from '@/utils/request'
import { checkAuth } from '@/utils/auth'
export default {
  name: 'CaseDetail',
  data() {
    return {
      isConsultVisible: false,
      isDownloadVisible: false,
      chargeAmount: '0',
      caseInfo: {},
      ratings: [],
      selectedPaymentMethod: 'wechat', // 选择的支付方式，默认微信支付
      paymentData: {}, // 支付数据
      orderId: '', // 订单ID
      isCollected: false,
      showImagePreview: false, // 是否显示图片预览
      currentImageIndex: 0 // 当前显示的图片索引
    }
  },
  computed: {
    displayAmount() {
      return this.caseInfo.price || this.chargeAmount
    },
    effectDiagramList() {
      if (Array.isArray(this.caseInfo.effect_diagram)) {
        return this.caseInfo.effect_diagram.filter(Boolean)
      }
      if (typeof this.caseInfo.effect_diagram === 'string' && this.caseInfo.effect_diagram) {
        return this.caseInfo.effect_diagram.split(',').map(s => s.trim()).filter(Boolean)
      }
      return []
    },
    // 收集所有图片
    allImages() {
      const images = []
      // 先添加 cover_image
      if (this.caseInfo.cover_image) {
        images.push(this.caseInfo.cover_image)
      }
      // 添加 effect_diagram（支持逗号分隔字符串）
      this.effectDiagramList.forEach(diagram => {
        if (diagram && !images.includes(diagram)) {
          images.push(diagram)
        }
      })
      // 处理 images 数组或字符串
      let imageList = []
      if (Array.isArray(this.caseInfo.images) && this.caseInfo.images.length > 0) {
        imageList = this.caseInfo.images
      } else if (typeof this.caseInfo.images === 'string' && this.caseInfo.images) {
        // 如果是字符串，按逗号分割
        imageList = this.caseInfo.images.split(',').map(s => s.trim()).filter(Boolean)
      }
      // 添加 images 中的图片，去重
      imageList.forEach(img => {
        if (img && !images.includes(img)) {
          images.push(img)
        }
      })
      return images
    }
  },
  created() {
    this.fetchDetail()
    // 如果已登录且已返回此字段也可设置 isCollected
  },
  methods: {
    async fetchDetail() {
      try {
        const id = this.$route.query.id
        const { data } = await getCostCaseDetail(id)
        if (data && data.case_info) {
          this.caseInfo = data.case_info
          // 如果后端返回带 is_collected 字段就用，不然默认false
          this.isCollected = !!data.case_info.is_collected
          this.ratings = Array.isArray(data.ratings) ? data.ratings : []
          if (this.caseInfo && this.caseInfo.price) {
            this.chargeAmount = String(this.caseInfo.price)
          }
        }
      } catch (e) {
        console.error('获取案例详情失败:', e)
      }
    },
    viewMoreImages() {
      if (this.allImages.length === 0) {
        this.$message && this.$message.info('暂无更多图片')
        return
      }
      this.currentImageIndex = 0
      this.showImagePreview = true
    },
    closeImagePreview() {
      this.showImagePreview = false
      this.currentImageIndex = 0
    },
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--
      }
    },
    nextImage() {
      if (this.currentImageIndex < this.allImages.length - 1) {
        this.currentImageIndex++
      }
    },
    goToImage(index) {
      this.currentImageIndex = index
    },
    // 获取案例图片列表（用于页面显示）
    getCaseImages() {
      return this.allImages.length > 0 ? this.allImages : (this.caseInfo.cover_image ? [this.caseInfo.cover_image] : [])
    },
    // 跳转到案例详情页面
    goToCaseNews() {
      const caseId = this.caseInfo.id || this.$route.query.id
      this.closeImagePreview()
      this.$router.push({
        path: '/costcases/caseNews',
        query: { id: caseId }
      })
    },
    goBack() {
      this.$router.back()
    },
    goConsult() {
      // 检查登录状态
      if (!checkAuth(this.$router, '请先登录后再进行咨询')) {
        return
      }
      // 从案例信息中获取造价师ID，如果没有则使用默认值
      const engineerId = this.caseInfo.cost_engineer_id || this.caseInfo.engineer_id || 1
      this.$router.push({
        path: '/consulting/index',
        query: { cost_engineer_id: engineerId }
      })
    },
    closeAll() {
      this.isConsultVisible = false
      this.isDownloadVisible = false
      // 重置支付数据
      this.paymentData = {}
      this.orderId = ''
      this.selectedPaymentMethod = 'wechat'
    },
    async toDownloadFromConsult() {
      this.isConsultVisible = false
      this.isDownloadVisible = true
    },
    async confirmDownload() {
      if (!this.selectedPaymentMethod) {
        this.$message && this.$message.warning('请选择支付方式')
        return
      }
      const paid = await this.createPaymentOrder(this.selectedPaymentMethod)
      if (!paid) return
      this.$message && this.$message.success('支付订单创建成功')
      this.closeAll()
      await this.fetchDetail()
    },
    async selectPaymentMethod(method) {
      this.selectedPaymentMethod = method
    },
    async createPaymentOrder(paymentMethod) {
      try {
        const caseId = this.caseInfo.id || this.$route.query.id
        const response = await createPayOrder({
          case_id: caseId,
          payment_method: paymentMethod
        })

        if (response && response.code === 1 && response.data) {
          this.paymentData = response.data
          this.orderId = response.data.order_id
          return true
        } else {
          this.$message && this.$message.error(response?.msg || '创建订单失败')
          return false
        }
      } catch (error) {
        console.error('创建支付订单失败:', error)
        this.$message && this.$message.error('创建订单失败，请重试')
        return false
      }
    },
    async handleDownload() {
      // 检查登录状态
      if (!checkAuth(this.$router, '请先登录后再进行下载')) {
        return
      }
      if (this.caseInfo && Number(this.caseInfo.is_free) === 1) {
        // 免费直接下载
        await this.downloadFile()
      } else {
        // 收费弹出支付弹窗
        this.isDownloadVisible = true
      }
    },
    async handleCollect() {
      // 检查登录状态
      if (!checkAuth(this.$router, '请先登录后再进行收藏')) {
        return
      }
      if (!this.caseInfo.id) return
      const action = this.isCollected ? 'cancel' : 'collect'
      try {
        const res = await collectCase({ case_id: this.caseInfo.id, action })
        if (res && res.code === 1) {
          this.isCollected = !this.isCollected
          this.$message && this.$message.success(action === 'collect' ? '已收藏' : '已取消收藏')
        } else {
          this.$message && this.$message.error(res?.msg || '操作失败')
        }
      } catch (e) {
        this.$message && this.$message.error('操作失败')
      }
    },
    async downloadFile() {
      try {
        const id = this.$route.query.id
        const response = await request({
          url: '/api/cost_case/recordDownload',
          method: 'get',
          params: { id }
        })
        if (response && response.data) {
          // 拼接域名获取完整下载链接
          const downloadUrl = this.$getImageUrl(response.data)

          // 创建下载链接并触发下载
          const link = document.createElement('a')
          link.href = downloadUrl
          link.download = '' // 让浏览器自动获取文件名
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          this.$message && this.$message.success('开始下载...')
        } else {
          this.$message && this.$message.error('获取下载链接失败')
        }
      } catch (error) {
        console.error('下载失败:', error)
        this.$message && this.$message.error('下载失败，请重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.case-detail-container {
	width: var(--page-wide-ratio, 75%);
  min-height: 100vh;
  padding: 20px;
  margin: 0 auto;
}

/* 弹窗样式 */
.zf-modal-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.zf-modal {
  position: relative;
  width: 560px;
  background: #fff;
  border-radius: 10px;
  padding: 24px 28px 28px;
}

.zf-modal-close {
  position: absolute;
  right: 12px;
  top: 12px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.zf-modal-title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.zf-modal-file {
  display: flex;
  align-items: center;
  background: #f7f8fa;
  border-radius: 8px;
  padding: 12px;
}

.zf-file-icon {
  width: 36px;
  height: 36px;
  margin-right: 12px;
}

.zf-file-meta {
  display: flex;
  flex-direction: column;
}

.zf-file-name { font-size: 14px; font-weight: 600; color: #333; }
.zf-file-sub { font-size: 12px; color: #999; margin-top: 4px; }

.zf-modal-tip {
  text-align: center;
  color: #9aa0a6;
  margin: 18px 0 16px;
}

.zf-primary-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(90deg, #1677ff 0%, #1e6ce2 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.zf-form { margin-top: 8px; }

.zf-input {
  position: relative;
  height: 44px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding-left: 28px;
  margin-bottom: 14px;
}
 .zf-input-prefix { position: absolute; left: 10px; color: #999; }
 .zf-input input { flex: 1; height: 100%; border: none; outline: none; font-size: 14px; }

 .zf-payment-methods {
   margin-bottom: 14px;

   .payment-title {
     font-size: 14px;
     font-weight: 600;
     color: #333;
     margin-bottom: 10px;
   }

   .payment-options {
     display: flex;
     gap: 12px;

     .payment-option {
       flex: 1;
       display: flex;
       align-items: center;
       justify-content: center;
       gap: 8px;
       padding: 12px 16px;
       border: 1px solid #e5e6eb;
       border-radius: 6px;
       cursor: pointer;
       transition: all 0.3s ease;

       &:hover {
         border-color: #0f6fe2;
         background: #f0f8ff;
       }

       &.active {
         border-color: #0f6fe2;
         background: #f0f8ff;
         color: #0f6fe2;
       }

       img {
         width: 20px;
         height: 20px;
       }

       span {
         font-size: 14px;
         font-weight: 500;
       }

       .yue-icon {
         width: 20px;
         height: 20px;
         border-radius: 50%;
         background: #f39800;
         color: #fff;
         display: inline-flex;
         align-items: center;
         justify-content: center;
         font-size: 12px;
         font-weight: 700;
       }
     }
   }
 }

.zf-paybox { display: flex; gap: 16px; align-items: center; }
.zf-qrcode {
  width: 120px;
  height: 120px;
  background: #f2f3f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.qr-code-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.qr-placeholder {
  font-size: 12px;
  color: #999;
}
.zf-payinfo { flex: 1; }
.zf-amount { margin-bottom: 8px; }
.zf-amount span { color: #f5222d; font-weight: 700; }
.zf-paytypes { display: flex; align-items: center; gap: 6px; color: #86909c; margin: 6px 0; }
.zf-paytypes img { width: 20px; height: 20px; }
.zf-agree { color: #b8b8b8; font-size: 12px; }

.breadcrumb-section {
  background: #fff;
  padding: 20px 30px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    .breadcrumb-item {
      color: #000000;
      &.link { cursor: pointer; color: #0F70E2; }
    }

    .breadcrumb-separator {
      margin: 0 8px;
      color: #999;
    }
  }
}

.view-more-section {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 30px;

  .images-container {
    display: flex;
    gap: 20px;
    flex: 1;

    .image-card {
      flex: 1;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
      }

      .case-image {
        width: 100%;
        height: 300px;
        object-fit: cover;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .view-more {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    color: #0F70E2;
    font-size: 14px;
    transition: color 0.3s ease;
    min-width: 80px;
    writing-mode: vertical-rl;
    text-orientation: mixed;

    &:hover {
      color: #0c5bc7;
    }

    .view-more-icon {
      width: 20px;
      height: 20px;
      margin-bottom: 8px;
             object-fit: contain;
       margin-left: 20px;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .view-more-section {
    flex-direction: column;
    gap: 20px;

    .images-container {
      flex-direction: column;
      gap: 15px;
    }

    .view-more {
      flex-direction: row;
      gap: 8px;
      min-width: auto;
      writing-mode: horizontal-tb;
      text-orientation: mixed;

      .view-more-icon {
        margin-bottom: 0;
        margin-right: 5px;
      }
    }
  }
}

@media (max-width: 480px) {
  .case-detail-container {
    width: 95%;
    padding: 10px;
  }

  .view-more-section {
    padding: 20px;
  }
}

.project-content {
  background: #fff;
  padding: 30px;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .document-info {
    margin-bottom: 30px;

    .document-header {
      display: flex;
      align-items: center;
      gap: 15px;

      .document-icon {
        width: 40px;
        height: 40px;
        background: #4CAF50;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 20px;
      }

      .document-title {
        flex: 1;
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }

      .document-meta {
        display: flex;
        gap: 15px;
        font-size: 14px;
        color: #666;

        .preview {
          color: #0F70E2;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .project-rendering {
    margin-bottom: 30px;

    .section-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
    }

    .rendering-image {
      .project-image {
        width: 100%;
        height: 300px;
        object-fit: contain;
        background: #f5f7fa;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .action-buttons {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;

    .btn {
      flex: 1;
      padding: 15px 30px;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &.btn-consult {
        background: #0F70E2;
        color: #fff;

        &:hover {
          background: #0c5bc7;
        }
      }

      &.btn-download {
        background: #F39800;
        color: #fff;

        &:hover {
          background: #F39800;
        }
      }

      i {
        font-size: 18px;
      }
    }
  }
}

// 图片预览弹窗样式
.image-preview-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.image-preview-container {
  position: relative;
  width: 90vw;
  max-width: 1200px;
  height: 90vh;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.preview-close-btn {
  width: 30px;
  height: 30px;
  cursor: pointer;
  flex-shrink: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 5px;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
}

  .preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    border-bottom: 1px solid #e5e6eb;
    background: #fff;

    .preview-title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }

    .preview-header-actions {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;
    }

    .preview-counter {
      font-size: 14px;
      color: #666;
    }

    .preview-jump-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px;
      background: #0F70E2;
      color: #fff;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.3s ease;

      &:hover {
        background: #0c5bb8;
        transform: translateX(2px);
      }

      i {
        font-size: 16px;
      }
    }
  }

.preview-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  overflow: hidden;
  background: #000;

  .preview-image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .preview-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 8px;
  }
}

.preview-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  pointer-events: none;

  .nav-btn {
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    pointer-events: auto;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      background: rgba(0, 0, 0, 0.7);
      transform: scale(1.1);
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }

    &.prev-btn {
      left: 20px;
    }

    &.next-btn {
      right: 20px;
    }
  }
}

.thumbnail-nav {
  display: flex;
  gap: 10px;
  padding: 20px 30px;
  background: #fff;
  border-top: 1px solid #e5e6eb;
  overflow-x: auto;
  justify-content: center;

  .thumbnail-item {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 3px solid transparent;
    transition: all 0.3s ease;
    flex-shrink: 0;

    &.active {
      border-color: #0F70E2;
    }

    &:hover {
      transform: scale(1.05);
    }

    .thumbnail-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.user-rating-section {
	background: #fff;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	margin-top: 20px;
    .rating-header {
      margin-bottom: 20px;

      .rating-label {
        background: #0F70E2;
        color: #fff;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }

    .reviews-list {
      .review-item {
        padding: 15px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        .user-avatar {
          margin-right: 10px;
          .avatar-img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .review-content {
          display: flex;
          align-items: center;

          .user-info {
            display: flex;
            flex-direction: column;
            gap: 5px;

            .username {
              font-size: 14px;
              font-weight: bold;
              color: #333;
            }

            .review-date {
              font-size: 12px;
              color: #999;
            }
          }
        }

        .rating-stars {
            display: flex;
            align-items: center;
            margin-top: 10px;

            .star-icon {
              width: 20px;
              height: 20px;
              object-fit: contain;
              margin-right: 10px;
            }

            .rating-score {
              margin-left: 10px;
              font-size: 16px;
              color: #F39800;
              font-weight: bold;
            }
          }
      }
    }
  }

// 响应式设计
@media (max-width: 768px) {
  .project-content {
    padding: 20px;

    .document-info {
      .document-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;

        .document-meta {
          flex-direction: column;
          gap: 5px;
        }
      }
    }

    .action-buttons {
      flex-direction: column;
      gap: 15px;
    }
  }
}

/* 收藏按钮样式 */
.btn-fav {
  margin-left: 16px;
  background: #ffedcc;
  color: #ff9800;
  border: none;
  border-radius: 5px;
  padding: 8px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: 0.2s;
}
.btn-fav.collected {
  background: #ffc107;
  color: #fff;
}
</style>
